export const CONTACT = {
  email: "nmurthygroups@gmail.com",
  website: "www.nmurthy.com",
  address: "Tavarekere, Doddaladamara Road, Basavanapalya, Bengaluru South — 562130",
  phones: ["+91 73491 39671", "+91 96068 34999", "+91 86183 24696"],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1772693109381-620f0622646b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBsYW5kc2NhcGUlMjBzdW5zZXQlMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc4NzA0MTY0M3ww&ixlib=rb-4.1.0&q=85",
  entrance: "https://images.pexels.com/photos/28463543/pexels-photo-28463543.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  aerial: "https://images.pexels.com/photos/11201060/pexels-photo-11201060.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  lake: "https://images.unsplash.com/photo-1730205157406-783fe5999ad3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxsYW5kc2NhcGVkJTIwcGFyayUyMGdyZWVuJTIwbGFrZSUyMGNvbW11bml0eSUyMGFtZW5pdGllc3xlbnwwfHx8fDE3ODcwNDE3MTF8MA&ixlib=rb-4.1.0&q=85",
  park: "https://images.unsplash.com/photo-1662657274716-29b894825442?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxsYW5kc2NhcGVkJTIwcGFyayUyMGdyZWVuJTIwbGFrZSUyMGNvbW11bml0eSUyMGFtZW5pdGllc3xlbnwwfHx8fDE3ODcwNDE3MTF8MA&ixlib=rb-4.1.0&q=85",
  field: "https://images.unsplash.com/photo-1587966783152-ca9cda6b3052?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBlbXB0eSUyMGxhbmQlMjBwbG90cyUyMHJlYWwlMjBlc3RhdGV8ZW58MHx8fHwxNzg3MDQxNjU0fDA&ixlib=rb-4.1.0&q=85",
  driveway: "https://images.unsplash.com/photo-1774533566123-faecfb3020eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnYXRlZCUyMGNvbW11bml0eSUyMGVudHJhbmNlJTIwZ2F0ZSUyMHJvYWR8ZW58MHx8fHwxNzg3MDQxNzIyfDA&ixlib=rb-4.1.0&q=85",
};

export const INFRASTRUCTURE = [
  { title: "Concrete Roads", desc: "60ft main road & 30ft sub roads, built to last." },
  { title: "Brick Compound", desc: "Fully secured masonry compound wall around the layout." },
  { title: "Underground Electric Line", desc: "No overhead cables — clean, safe streetscape." },
  { title: "Underground Sewage Line", desc: "Modern planned drainage across every plot." },
  { title: "Underground Storm Water", desc: "Engineered storm-water management." },
  { title: "24×7 CCTV Surveillance", desc: "Round-the-clock monitored security." },
  { title: "Security Guard", desc: "Manned gate with quick-response protocol." },
  { title: "Overhead Tank", desc: "Elevated water storage ensuring a steady supply to every plot." },
  { title: "EV Charging Point", desc: "Planned as the community grows." },
];

export const AMENITIES = [
  "Children's Play Area", "Community App", "Senior Citizen Area", "Parks",
  "Badminton Court", "Cricket Ground", "Basketball Court", "Volleyball Court", "Lake",
];

export const PLOTS = [
  { size: "30 × 40", note: "Compact & efficient" },
  { size: "30 × 50", note: "Popular family choice" },
  { size: "40 × 60", note: "Spacious premium plot" },
  { size: "Odd Sites", note: "Unique corner & garden layouts" },
];

export const LEGAL = [
  "BMRDA Approved (A-Katha)",
  "Clear Title Property",
  "Ready for Registration",
  "Approved Residential Layout",
  "Bank Loan Facility Available",
];

export const LANDMARKS = [
  { place: "Kengeri Metro Station", dist: "10 km" },
  { place: "RajaRajeshwari Medical College & Hospital", dist: "8 km" },
  { place: "Mysore Road", dist: "9 km" },
  { place: "Nadaprabhu Kempegowda Layout", dist: "5 km" },
  { place: "Magadi Road", dist: "5 km" },
];
